module.exports = __webpack_public_path__ + "static/media/EW_0013_01.11aa0018.png";